import Header from '@/components/receipt/Header';
import ReceiptList from '@/components/receipt/ReceiptList';
import Layout from '@/components/receipt/Layout';
import { useReceipts } from '@/hooks/useReceipts';
import { AddReceiptEnrichButton } from '@/components/ui/AddReceiptButtonEnrich';
import { ReceiptItemLoader } from '@/components/receipt/ReceiptItemLoader';

export default function Receipts() {
  const receiptsQuery = useReceipts();
  const receipts = receiptsQuery.data?.data;

  return (
    <>
      <Layout>
        <Header />
        <div className="mx-auto max-w-md">
          {receiptsQuery.isLoading && <ReceiptItemLoader />}
          {receipts && <ReceiptList receipts={receipts} />}
        </div>
        <AddReceiptEnrichButton />
      </Layout>
    </>
  );
}
